import { RequestBaseService } from './../../../services/http-base/request-base.service';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormControlStatus,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import {
  AllInputTypes,
  ChangeEffection,
  FormInputConfig,
  FormValidation,
} from '../../../interfaces/form-input-config';
import { LiveTranslateService } from '../../../services/live-translate.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormFieldComponent } from '../form-field/form-field.component';
import { environment } from '../../../../../../assets/environment/environment';
import { convertToLocalUtcDate } from '../../../../../common/core/utilities/formatting/date.formatting';
import { Logger } from '../../../../../common/core/utilities/logging/logger';
import { IValidationErrors } from '../../../interfaces/shared-interfaces';

declare var $: any;
@Component({
  selector: 'app-form',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormFieldComponent],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent {
  // Add New Button Emit
  @Output() onAddNew: EventEmitter<FormInputConfig> =
    new EventEmitter<FormInputConfig>();

  resetRecaptcha: boolean = false;
  captchaExist: boolean = false;
  @Input({ required: true }) formConfig: FormInputConfig[] = [];
  @Input() allFormFields: FormInputConfig[] = [];
  @Input() formValidation: FormValidation[] = [];
  @Input() patchValues: { [key: string]: any } = [];
  @Input() validationErrors: IValidationErrors = {};
  @Input() buttonText: string = 'submit';
  @Input() resetButtonText: string = 'Clear';
  @Input() changeSensitive: boolean = false;
  @Input() hasButton: boolean = true;
  @Input() hasResetButton: boolean = false;
  @Input() inlineButton: boolean = false;
  @Input() validationEmit: boolean = false;
  @Input() buttonClass: string = '';
  @Input() buttonPos: string = '';
  @Input() buttonWidthClass: string = 'w-100';
  @Input() hasCancelButton: boolean = false;
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetFormClicked: EventEmitter<boolean> = new EventEmitter<any>();
  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLabelClick: EventEmitter<FormInputConfig> =
    new EventEmitter<FormInputConfig>();
  @Output() formStatus: EventEmitter<FormControlStatus> = new EventEmitter();
  @Output() onFilterSelectField: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDownloadFile: EventEmitter<string> = new EventEmitter<string>();
  formStatus$!: Subscription;
  ListLoadChanged: boolean = false;
  files: any = {};
  casheItems: any = {};
  formArraies: {
    formItem: FormInputConfig;
    index: number;
    parentIndex?: number;
  }[] = [];

  storeChangeEffection: {
    form: UntypedFormGroup;
    changeEffect: ChangeEffection[];
    value: any;
    newFormConfig: FormInputConfig[];
  }[] = [];

  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  formError = '';

  ckeConfig: any = {
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      {
        name: 'editing',
        groups: ['find', 'selection', 'spellchecker', 'editing'],
      },
      { name: 'forms', groups: ['forms'] },
      '/',
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      {
        name: 'paragraph',
        groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
      },
      { name: 'links', groups: ['links'] },
      '/',
      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] },
    ],
    removeButtons:
      'Source,Save,NewPage,ExportPdf,Preview,Print,Templates,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Image,About,SelectAll,Scayt,Iframe',
    extraPlugins:
      'easyimage,dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,' +
      'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
      'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
      'filebrowser,find,fakeobjects,flash,floatingspace,listblock,richcombo,' +
      'font,format,forms,horizontalrule,htmlwriter,iframe,indent,' +
      'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
      'maximize,newpage,pagebreak,pastefromword,pastetext,preview,print,' +
      'removeformat,resize,save,menubutton,scayt,selectall,showblocks,' +
      'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
      'tabletools,templates,toolbar,undo,wsc,wysiwygarea',
  };

  currentLang: string = 'en';

  cachedItem: any = {};

  viewForm: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private liveTranslate: LiveTranslateService,
    private cdr: ChangeDetectorRef,
    private dynamicLoadDataService: RequestBaseService
  ) { }

  ngOnInit(): void {
    // Prevent focus on first element element
    setTimeout(() => {
      this.viewForm = true;
    }, 0);

    this.files = {};
    this.allFormFields = [];
    this.liveTranslate.getLangValues();
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = this.translate.currentLang;
    });
    const formValidators =
      this.formValidation.length > 0
        ? this.formValidation.map((validation) => validation.function)
        : null;
    this.formGroup = this.fb.group({});
    this.cureatConfigedForm(this.filetrForm(this.formConfig));
    this.formGroup.setValidators(formValidators);
    this.changeSubmit();
    this.currentLang = this.translate.currentLang;

    for (const change of this.storeChangeEffection) {
      this.changeEffection(
        change.form,
        change.changeEffect,
        change.value,
        change.newFormConfig
      );
    }
    for (const item of this.formArraies) {
      this.makeFormArray(item.formItem, item.index, item.parentIndex);
    }
    this.formArraies = [];
    this.storeChangeEffection = [];

    this.formStatus.emit(this.formGroup.status);
    this.formStatus$ = this.formGroup.statusChanges.subscribe({
      next: (status) => {
        this.formStatus.emit(status);
      },
    });
  }

  onAddNewEmitter(event: any): void {
    this.onAddNew.emit(event);
  }

  onFilterField(e: any) {
    this.onFilterSelectField.emit(e);
  }

  onDownloadFileitem(fileId: string) {
    this.onDownloadFile.emit(fileId);
  }
  onSelectItem(e: any) {
    this.onSelectedItem.emit(e);
  }

  resetForm() {
    this.resetFormClicked.emit(true);
    // this.formGroup.reset()
  }

  filetrForm(formGroupConfig: FormInputConfig[]) {
    return formGroupConfig.filter(
      (formItem: FormInputConfig) => formItem.type != AllInputTypes.ViewText
    );
  }

  cureatConfigedForm(formGroupConfig: FormInputConfig[], parentIndex?: number) {
    formGroupConfig.forEach((formItem: FormInputConfig, index: number) => {
      if (formItem.type == AllInputTypes.Group) {
        // Create a form array for this group
        this.cureatConfigedForm(
          this.filetrForm(formItem.groupList ?? []),
          index
        );
      } else {
        // Otherwise, treat it as a regular field
        this.allFormFields.push(formItem);
        this.checkFun(formItem, index, parentIndex);
      }
    });
  }

  checkFun(formItem: FormInputConfig, index: number, parentIndex?: number) {
    if (formItem.type == AllInputTypes.Array) {
      this.formArraies.push({ formItem, index, parentIndex });
      // }
    } else {
      this.addFormController(this.formGroup, formItem);
      // this.formGroup.addControl(formItem.name, res);
    }
    return true;
  }
  makeFormArray(
    formItem: FormInputConfig,
    index: number,
    parentIndex?: number
  ) {
    this.formGroup.addControl(formItem.name, this.fb.array([]));
    // if ((formItem.ArrayConfigration?.list.length ?? 0) > 0) {
    let arr = [...(formItem.ArrayConfigration?.defualtValue ?? [])];
    if (formItem.ArrayConfigration) formItem.ArrayConfigration.list = [];
    for (let item of arr) {
      this.addFormArray(parentIndex ?? index, item, index);
    }
    return true;
  }

  addFormController(form: UntypedFormGroup, fieldConfig: FormInputConfig, formConfig?: FormInputConfig[]) {
    const newFormConfig = formConfig ?? this.allFormFields;
    const devIgnorCaptcha =
      (environment.apiUrl.indexOf('app-dev.') > -1 &&
        fieldConfig.type !== AllInputTypes.Captcha) ||
      environment.apiUrl.indexOf('app-dev.') == -1;

    let validations =
      fieldConfig.validation && devIgnorCaptcha
        ? fieldConfig.validation.map((validation) => {
          fieldConfig.isRequired = validation.function == Validators.required;
          return validation.function;
        })
        : null;

    // Check if the field type is a Group (FormArray)
    if (fieldConfig.type === AllInputTypes.Group) {
      // If the field is a group, create a FormArray
      const formArray = this.fb.array([]);
      fieldConfig.groupList?.forEach((item) => {
        const groupControl = this.fb.group({});
        this.addFormController(groupControl, item, newFormConfig);  // Recursively add each group's field
        formArray.push(groupControl);
      });
      form.addControl(fieldConfig.name, formArray);
    } else {
      // Handle other types of fields
      const control = this.fb.control(
        fieldConfig.type != AllInputTypes.DropFile ? fieldConfig.defaultValue : [],
        validations
      );

      if (fieldConfig.changeEffect) {
        // Handle changeEffect logic
        const changeField = {
          form,
          changeEffect: fieldConfig.changeEffect,
          value: control.value,
          newFormConfig,
        };
        this.storeChangeEffection.push(changeField);
        control.valueChanges.subscribe((value) => {
          this.changeEffection(form, fieldConfig.changeEffect ?? [], value, newFormConfig ?? []);
        });
      }

      if (fieldConfig.isDisable) {
        control.disable({ onlySelf: true });
      }

      if (fieldConfig.change) {
        const boundUpdateFieldConfig = updateFieldConfig.bind(null, this.allFormFields);
        control.valueChanges.subscribe((value) => {
          fieldConfig.change
            ? fieldConfig.change(value, formConfig ?? this.allFormFields, form, this.formConfig, boundUpdateFieldConfig)
            : null;
          this.cdr.detectChanges();
        });
      }

      if (fieldConfig.isSearch) {
        control.valueChanges.pipe(debounceTime(1000)).subscribe((value) => {
          this.submit();
        });
      }

      if (fieldConfig.listLoad) {
        if (!fieldConfig.listLoad.loadOnChange) this.loadListDate(fieldConfig);
        else if (fieldConfig.listLoad.loadOnChange) {
          if (fieldConfig.listLoad.defualtLoadValue)
            this.loadListDate(fieldConfig, fieldConfig.listLoad.defualtLoadValue);

          form
            .get(fieldConfig.listLoad.loadOnChange)
            ?.valueChanges.subscribe((value) => {
              this.loadListDate(fieldConfig, value);
              form.get(fieldConfig.name)?.setValue(null);
            });
        }
      }

      form.addControl(fieldConfig.name, control);
    }

    return true;
  }

  async loadListDate(formItem: FormInputConfig, value: any = null) {
    try {
      if (formItem.listLoad) {
        // formItem.listLoad.loadService.setParams({ ...(formItem.listLoad.params ? formItem.listLoad.params : {}) })
        if (formItem.listLoad.prepareRequest)
          formItem.listLoad.prepareRequest(
            formItem.listLoad.loadService,
            value
          );
        // else
        //   formItem.listLoad.loadService.setPath(formItem.listLoad.url + `/${value}`);
        let res: any;
        formItem.listLoad?.type == 'get'
          ? (res = await formItem.listLoad.loadService.get({
            params: {
              ...(formItem.listLoad.params ? formItem.listLoad.params : {}),
            },
            path: formItem.listLoad.loadOnChange
              ? formItem.listLoad.url + `/${value}`
              : formItem.listLoad.url,
            isLoad: !!formItem.listLoad.showLoader,
          }))
          : (res = await formItem.listLoad.loadService.post({
            params: {
              ...(formItem.listLoad.params ? formItem.listLoad.params : {}),
            },
            path: formItem.listLoad.loadOnChange
              ? formItem.listLoad.url + `/${value}`
              : formItem.listLoad.url,
            isLoad: !!formItem.listLoad.showLoader,
          }));
        if (res[formItem.listLoad?.arrayAttributeName]) {
          if (res[formItem.listLoad?.arrayAttributeName].length) {
            formItem.listValues = [
              ...(formItem.listLoad.subData ?? []),
              ...(formItem.listLoad.responseDataPrepare
                ? formItem.listLoad.responseDataPrepare(
                  res[formItem.listLoad?.arrayAttributeName]
                )
                : res[formItem.listLoad?.arrayAttributeName].map(
                  (item: any) => {
                    return {
                      value: item[formItem.listLoad?.valueKey || ''],
                      label: item[formItem.listLoad?.labelKey || ''],
                    };
                  }
                )),
            ];
            if (formItem.isUnique) {
              formItem['listValuesCopy'] = formItem.listValues;
            }
            if (formItem.listLoad.getPreparedData) {
              formItem.listLoad.getPreparedData(formItem.listValues);
            }
            formItem['isOpen'] = true;
            if (
              this.casheItems[formItem.name] &&
              this.casheItems[formItem.name].classElement
            )
              this.casheItems[formItem.name].classElement.isOpen = true;
          } else {
            formItem.listValues = [...(formItem.listLoad.subData ?? [])];
            if (formItem.isUnique) {
              formItem['listValuesCopy'] = formItem.listValues;
            }
            this.formGroup.patchValue({
              [formItem.name]: null,
            });
          }
          if (formItem.isUnique) {
            this.ListLoadChanged = !this.ListLoadChanged;
          }
        }
      }
      return true;
    } catch (error: any) {
      return false;
    }
  }

  // findformField(field: FormInputConfig, item: ChangeEffection) {
  //   if (field.type == AllInputTypes.Group) {
  //     return field?.groupList?.filter((field: FormInputConfig) => this.findformField(field, item))[0]
  //   }
  //   return field.name === item.field
  // }

  changeEffection(
    form: UntypedFormGroup,
    allEffestions: ChangeEffection[],
    currentValue: any,
    formGroup: FormInputConfig[]
  ) {
    for (const item of allEffestions) {
      let newFieldConfig = formGroup.filter(
        (field: FormInputConfig) => field.name === item.field
      )[0];
      if (currentValue != item.showWhen) {
        newFieldConfig.hide = true;
        form.removeControl(item.field);
      } else if (currentValue == item.showWhen) {
        newFieldConfig.hide = false;
        if (!form.get(item.field)) this.addFormController(form, newFieldConfig);
      }
    }
    return true;
  }

  changeSubmit() {
    if (this.changeSensitive) {
      this.formGroup.valueChanges.subscribe(() => {
        // Find items of type AllInputTypes.DateTime and log them
        const dateTimeFields = this.formConfig.filter(
          (item: any) => item.type === AllInputTypes.DateTime
        );

        dateTimeFields.forEach((dateTimeField: FormInputConfig) => {
          if (dateTimeField?.isDateTimePickerZoneUtc === true) {
            const fieldName = dateTimeField.name;
            if (this.formGroup.value[fieldName]) {
              // Convert the value to UTC and update it in formGroup
              this.formGroup.value[fieldName] = convertToLocalUtcDate(
                this.formGroup.value[fieldName]
              );
            }
          }
        });

        // Emit the form values
        this.formConfig.forEach((fieldConfig: FormInputConfig) => {
          if (fieldConfig.type === AllInputTypes.Map) {
            const locationFieldValue = this.formGroup.value[fieldConfig.name];
            Logger.debug('Map field value:', locationFieldValue);

            // Ensure location object is correctly processed
            if (locationFieldValue && locationFieldValue.latitude && locationFieldValue.longitude) {
              // Update the form with latitude and longitude
              this.formGroup.value['latitude'] = locationFieldValue.latitude;
              this.formGroup.value['longitude'] = locationFieldValue.longitude;
            }

            Logger.debug('Form Group values:', this.formGroup.value);
          }

          if (fieldConfig.type === AllInputTypes.Group) {
            // Strongly typed formGroupValue
            let formGroupValue: Record<string, any> = {};

            fieldConfig?.groupList?.forEach((element) => {
              // Get the key name, and remove 'Group' if it exists
              let key = element.name;
              if (key.includes('Group')) {
                key = key.replace('Group', '');  // Removing 'Group' part from the key
              }

              // Assign the value from formGroup to formGroupValue
              formGroupValue[key] = this.formGroup.value[element.name];

              // Delete the element value from this.formGroup.value after assignment
              delete this.formGroup.value[element.name];
            });

            // Assign the modified formGroupValue to the main group key
            this.formGroup.value[fieldConfig.name] = formGroupValue;
          }
        });
        Logger.debug('Form Group values before emit:', this.formGroup.value);
        this.onChange.emit(this.formGroup.value);
      });
    }

    return true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    Logger.debug('changes: ', changes);
    if (changes['patchValues'] && changes['patchValues'].currentValue) {
      this.formGroup.patchValue(changes['patchValues'].currentValue);
    }
    if (changes['formConfig'] && changes['formConfig'].currentValue) {
      this.ngOnInit();
    }
    if (
      changes['validationEmit'] &&
      changes['validationEmit'].previousValue != null
    ) {
      this.submit();
    }
    this.changeSubmit();
  }

  submit() {
    this.formGroup.markAllAsTouched();
    this.formError = '';
    if (this.formGroup.valid) {
      this.onSubmit.emit({ ...this.formGroup.value, ...this.files });
      // if (this.captchaElem) this.captchaElem?.resetCaptcha();

      // triger changes to reset captcha by toggling @input value on formField component
      if (this.captchaExist) this.resetRecaptcha = !this.resetRecaptcha;
    }
    if (this.formGroup.errors) {
      const allErrors = this.formGroup.errors;
      this.formValidation.forEach((validation: FormValidation) => {
        if (
          allErrors &&
          (allErrors[validation.function.name] ||
            allErrors[validation.errorName ?? '']) &&
          this.formError == ''
        ) {
          this.formError = validation.errorMessage;
        }
      });
    }

    return true;
  }

  // resetForm() {
  //   this.formGroup.reset()
  //   // use this emition to reset inputs to default state inside component (re initForm Config)
  //   this.onResetForm.emit(true)
  // }

  isSimpleItem(itemType: AllInputTypes): boolean {
    return (
      [
        AllInputTypes.Text,
        AllInputTypes.Number,
        AllInputTypes.Email,
        AllInputTypes.Password,
        // AllInputTypes.ChooseFile,
      ].indexOf(itemType) > -1
    );
  }

  changeValue(event: any, itemName: string) {
    this.formGroup.get(itemName)?.setValue(event);
  }

  labelClick(event: any, formItem: FormInputConfig) {
    if (formItem.enabilLabelClick) {
      this.onLabelClick.emit(formItem);
    }
    return true;
  }

  removeFormArray(index: number, groupIndex: number, listIndex?: number) {
    let parent = this.formConfig[index];
    let groupList = parent?.groupList;
    if (listIndex != undefined && parent && groupList && groupList[listIndex]) {
      parent = groupList[listIndex];
    }
    parent?.ArrayConfigration?.list.splice(groupIndex, 1);
    (this.formGroup.get(parent?.name) as UntypedFormArray)?.removeAt(
      groupIndex
    );
    return index;
  }

  addFormArray(index: number, values?: any, listIndex?: number) {
    const groupBy = (objArray: any[], key: string) => {
      const groups: any[] = [];
      for (let obj of objArray) {
        const val = obj[key];
        //  if(groups[key]==null){
        //     groups[key]=[];
        //  }
        groups.push(val);
      }
      return groups;
    };
    let parent = this.formConfig[index];
    let groupList = parent.groupList;
    if (listIndex != undefined && parent && groupList && groupList[listIndex]) {
      parent = groupList[listIndex];
    }
    let items = $.extend(
      true,
      [],
      [...(parent?.ArrayConfigration?.fields ?? [])]
    );
    if (items) {
      const arrValues = this.formGroup.get(parent.name)?.value;
      const fieldsUnique = parent.ArrayConfigration?.fieldsUnique;
      let groupedValues: any = {};
      if (fieldsUnique) {
        const fields = Object.keys(fieldsUnique);
        for (let item of fields) {
          groupedValues[item] = groupBy(arrValues, item);
        }
      }
      const dataValues = values ?? parent.ArrayConfigration?.defualtItemValue;
      const newGroup = this.fb.group({});
      const effectsArr: FormInputConfig[] = [];
      for (let i = 0; i < items.length; i++) {
        items[i] = {
          ...items[i],
          defaultValue: dataValues[items[i].name ?? ''],
        };
        if (groupedValues[items[i].name]) {
          items[i].execludedValue = groupedValues[items[i].name];
        }

        if (items[i].changeEffect) effectsArr.push(items[i]);
        this.addFormController(newGroup, items[i], items);
      }
      let formArray = this.formGroup.get(parent.name) as UntypedFormArray;
      for (let effect of effectsArr) {
        this.changeEffection(
          newGroup,
          effect.changeEffect ?? [],
          newGroup.get(effect.name)?.value,
          items
        );
      }
      newGroup?.patchValue(dataValues, { emitEvent: false });
      formArray?.push(newGroup);
    }
    parent.ArrayConfigration?.list.push(items);
    return index;
  }

  ngOnDestroy() {
    this.formStatus$?.unsubscribe();
  }
}
const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function updateFieldConfig(
  formConfig: FormInputConfig[],
  key: string,
  changes: Partial<FormInputConfig>
): void {
  const formField = formConfig.find((f) => f.name === key) || {};
  Object.assign(formField, changes);
}
